import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const FuturePage = () => {
  return (
    <Box
      sx={{
        height: '50vh',
        width: '100%',
        background: 'linear-gradient(-45deg, #000000, #000000, #000000, #000000)',
        backgroundSize: '400% 400%',
        animation: 'gradientMove 15s ease infinite',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 2,
        position: 'relative',
        '@keyframes gradientMove': {
          '0%': { backgroundPosition: '0% 50%' },
          '50%': { backgroundPosition: '100% 50%' },
          '100%': { backgroundPosition: '0% 50%' },
        },
      }}
    >
      <Box
        sx={{
          backdropFilter: 'blur(10px)',
          background: 'rgba(8, 8, 8, 0.35)',
          borderRadius: '20px',
          // boxShadow: '0 8px 32px 0 rgba(4, 161, 252, 0.7)',
          textAlign: 'center',
          padding: { xs: 4, md: 6 },
          maxWidth: '600px',
          color: '#fff',
          animation: 'fadeIn 2s ease-in-out',
          '@keyframes fadeIn': {
            '0%': { opacity: 0, transform: 'translateY(20px)' },
            '100%': { opacity: 1, transform: 'translateY(0)' },
          },
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            background: 'linear-gradient(90deg, #00C9FF, #92FE9D)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            letterSpacing: 2,
            marginBottom: 2,
          }}
        >
          The Journey Has Just Begun
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: '1.2rem',
            color: '#ddd',
            letterSpacing: 1,
            marginBottom: 4,
          }}
        >
          We're building the future—one idea at a time. Stay tuned for what’s next!
        </Typography>

        {/* <Button
          variant="outlined"
          sx={{
            color: '#fff',
            borderColor: '#00C9FF',
            paddingX: 4,
            paddingY: 1.2,
            fontWeight: 'bold',
            transition: 'all 0.3s ease',
            '&:hover': {
              background: '#00C9FF',
              color: '#000',
              borderColor: '#00C9FF',
            },
          }}
        >
          Discover More
        </Button> */}
      </Box>
    </Box>
  );
};

export default FuturePage;
